import React, { useState } from 'react';
import CampoObrigatorio from '../CampoObrigatorio/CampoObrigatorio';
import './InputPadraoLogin.css';

const InputPadraoLogin = ({
    value,
    className,
    onChange,
    titulo,
    obrigatorio,
    iconeLabel,
    icone,
    nome,
    placeholder,
    erro,
    type,
    onKeyDown
}) => {

    const [valorInput, setValorInput] = useState("");

    const handleInputChange = (e) => {
      let valor = e.target.value;
      if (valor === undefined) valor = "";

      setValorInput(valor);
      if (onChange) onChange(valor);
    }

    return (
      <div className={"container-input-padrao"}>
        <div className={"container-label-input-padrao"}>
          {titulo && (
            <div className={"principais-input-padrao"}>
              {iconeLabel}
              <label htmlFor={nome}> {titulo} </label>

              {obrigatorio && (
                <div className={"container-obrigatorio-input-padrao"}>
                  <CampoObrigatorio />
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className={`
            wrapper-icone-input
            ${erro ? "wrapper-icone-input-erro" : ""}
            ${valorInput.length > 0 ? "wrapper-icone-input-preenchido" : ""}
            ${className}
          `}
        >
          {icone && (
            <div className={`
              container-icone-input-padrao
              ${valorInput.length > 1 ? "container-icone-input-padrao-preenchido" : ""}
            `}>{icone}</div>
          )}

          <input
            className={`input-padrao-login ${icone ? "com-icone" : ""}`}
            type={type || "text"}
            onChange={(e) => handleInputChange(e)}
            name={nome}
            placeholder={placeholder}
            onKeyDown={onKeyDown}
          />
        </div>
      </div>
    );
    
}
 
export default InputPadraoLogin;